import React, { useEffect, useState } from "react";
import "./MyJourneyModal.css";
import axios from "axios";

const MyJourneyModal = ({ email, onClose }) => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [activeTab, setActiveTab] = useState("active");

  // Fetch bookings when modal opens
  useEffect(() => {
    const fetchBookings = async () => {
      try {
      const res = await axios.post("/api/booking/get-booking-by-email", { email });

        if (res.data.success) {
          setBookings(res.data.data);
        } else {
          setError(res.data.message || "No bookings found");
        }
      } catch (err) {
        setError("Error fetching bookings");
      } finally {
        setLoading(false);
      }
    };
    if (email) fetchBookings();
  }, [email]);

  // Helper function to categorize
const categorizeBookings = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const upcoming = [];
  const active = [];
  const past = [];

  bookings.forEach((b) => {
    const [startStr, endStr] = b.tripDate?.split(" - ") || [];

    const startDate = startStr ? new Date(startStr) : null;
    const endDate = endStr ? new Date(endStr) : null;

    if (!startDate || !endDate) {
      past.push(b);
      return;
    }

    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    if (today < startDate) {
      upcoming.push(b);
    } else if (today > endDate) {
      past.push(b);
    } else {
      active.push(b); // today is between start and end
    }
  });

  return { upcoming, active, past };
};


  const { upcoming, active, past } = categorizeBookings();

  // Render bookings list
    const renderBookings = (list, category) => {
    if (loading) return <p>Loading...</p>;
    if (error) return <p className="error">{error}</p>;
    if (!list || list.length === 0)
      return <p>No bookings found in this category.</p>;

    return (
      <div className="myjourneys-scroll">
        <div className="booking-list">
          {list.map((b, index) => (
            <div key={index} className="booking-card journey-card">
              
              {/* Trip Name */}
              <h3 className="journey-trip-name">{b.tripName}</h3>

              {/* Departure / Arrival */}
              <div className="row-between">
                <p><strong>Departure:</strong> {b.departure || "—"}</p>
                <p><strong>Arrival:</strong> {b.arrival || "—"}</p>
              </div>

              {/* Travellers */}
              <p>
                <strong>Travellers:</strong>{" "}
                {b.occupancy?.map(o => `${o.count} ${o.type}`).join(", ") || "—"}
              </p>

              {/* Trip Price */}
              <p><strong>Trip Price:</strong> ₹{b.totalAmount}</p>

              {/* Trip Dates */}
              {
  (() => {
    const [start, end] = b.tripDate?.split(" - ") || [];
    return (
      <p>
        <strong>Trip Dates:</strong>{" "}
        {start ? new Date(start).toLocaleDateString() : "—"} –{" "}
        {end ? new Date(end).toLocaleDateString() : "—"}
      </p>
    );
  })()
}

              {/* Buttons */}
              <div className="journey-buttons">
                {category === "active" && (
                  <>
                    <button className="btn-red">Support</button>
                    <button className="btn-yellow">Payment Due</button>
                  </>
                )}

                {category === "upcoming" && (
                  <>
                    <button className="btn-blue">Postpone</button>
                    <button className="btn-yellow">Payment Due</button>
                  </>
                )}

                {category === "past" && (
                  <>
                    <button className="btn-green">Review</button>
                  </>
                )}
              </div>

            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="journey-modal-overlay">
      <div className="journey-modal">
        <div className="modal-header">
          <h2>My Journeys</h2>
          <button onClick={onClose} className="close-btn">×</button>
        </div>

        <div className="tab-buttons">
          <button
            className={activeTab === "active" ? "active" : ""}
            onClick={() => setActiveTab("active")}
          >
            Active
          </button>
          <button
            className={activeTab === "upcoming" ? "active" : ""}
            onClick={() => setActiveTab("upcoming")}
          >
            Upcoming
          </button>
          <button
            className={activeTab === "past" ? "active" : ""}
            onClick={() => setActiveTab("past")}
          >
            Past
          </button>
        </div>

        <div className="modal-body">
       {activeTab === "active" && renderBookings(active, "active")}
{activeTab === "upcoming" && renderBookings(upcoming, "upcoming")}
{activeTab === "past" && renderBookings(past, "past")}

        </div>
      </div>
    </div>
  );
};

export default MyJourneyModal;
